var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Invoice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A solid styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M46.9 2L41 6l-6-4-6 4-6-4-6 4-6-4v54l6.1 6 6-4 6 4 6-4 6 4 6-4 6 4V8zM31 46H19a2 2 0 0 1 0-4h12a2 2 0 0 1 0 4zm4-8H19a2 2 0 0 1 0-4h16a2 2 0 0 1 0 4zM17 28a2 2 0 0 1 2-2h12a2 2 0 0 1 0 4H19a2 2 0 0 1-2-2zm18-6H19a2 2 0 0 1 0-4h16a2 2 0 0 1 0 4zm10 24h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm0-8h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm0-8h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm0-8h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4z",
    fill: "#253858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank6);
export default __webpack_public_path__ + "static/media/bank6.e2152e86a540e95fe58aa3d03dcba7ac.svg";
export { ForwardRef as ReactComponent };